module.exports = __webpack_public_path__ + "static/media/bg6.68016689.jpg";